import AdminDashboardView from '@/AdminDashboardView';
import ConsultantDashboardView from '@/ConsultantDashboardView';
import Attachments from '@/pages/admin/attachments/Attachments';
import BlackboardList from '@/pages/admin/blackboard/BlackboardList';
import Bonus from '@/pages/admin/bonus/Bonus';
import CallCenterPosition from '@/pages/admin/callCenterPosition/CallCenterPosition';
import CallHistoryCsv from '@/pages/admin/callHistoryCsv/CallHistoryCsv';
import CallingSearch from '@/pages/admin/callingSearch/CallingSearch';
import CCGamification from '@/pages/admin/ccGamification/CCGamification';
import CCHours from '@/pages/admin/ccHours/CCHours';
import CCPayment from '@/pages/admin/ccPayment/CCPayment';
import CCPaymentKDR from '@/pages/admin/ccPaymentKDR/CCPaymentKDR';
import CCPaymentShort from '@/pages/admin/ccPaymentShort/CCPaymentShort';
import ClaimNotEnded from '@/pages/admin/claimNotEnded/ClaimNotEnded';
import ClaimsSearch from '@/pages/admin/claimSearch/ClaimsSearch';
import ClaimsReport from '@/pages/admin/claimsReport/ClaimsReport';
import ClaimTag from '@/pages/admin/claimTag/ClaimTag';
import Companies from '@/pages/admin/companies/Companies';
import Contact from '@/pages/admin/contact/Contact';
import ContactsFilterTable from '@/pages/admin/contactFilters/ContactsFilterTable';
import ContactsRoad from '@/pages/admin/contactsRoad/ContactsRoad';
import CostPerLead from '@/pages/admin/costPerLeadReport/CostPerLead';
import DailyMarket from '@/pages/admin/dailyMarket/DailyMarket';
import DailyReport from '@/pages/admin/dailyReport/DailyReport';
import Dashboard from '@/pages/admin/dashboard/Dashboard';
import Department from '@/pages/admin/department/Department';
import Dictionary from '@/pages/admin/dictionary/Dictionary';
import DocumentsList from '@/pages/admin/documents/DocumentsList';
import DynamicMailAttachment from '@/pages/admin/dynamicMailAttachment/DynamicMailAttachment';
import DynamicMailContent from '@/pages/admin/dynamicMailContent/DynamicMailContent';
import EffectiveReport from '@/pages/admin/effectiveReport/EffectiveReport';
import FaqList from '@/pages/admin/faq/FaqList';
import File from '@/pages/admin/file/File';
import FollowUpPayments from '@/pages/admin/followUpPayments/FollowUpPayments';
import FollowUpShipments from '@/pages/admin/followUpShipments/FollowUpShipments';
import Gamification from '@/pages/admin/gamification/Gamification';
import GamificationNew from '@/pages/admin/gamificationNew/GamificationNew';
import HeadCcManagerScoringCalls from '@/pages/admin/headCcManagerScoringCalls/HeadCcManagerScoringCalls';
import HeadCcManagerScoringListening from '@/pages/admin/headCcManagerScoringListening/headCcManagerScoringListening';
import HoursReport from '@/pages/admin/hoursReport/HoursReport';
import InvoiceConfig from '@/pages/admin/invoiceConfig/InvoiceConfig';
import Invoices from '@/pages/admin/invoices/Invoices';
import InvoicesReport from '@/pages/admin/invoicesReport/InvoicesReport';
import InvoiceTemplates from '@/pages/admin/invoiceTemplates/InvoiceTemplates';
import Keys from '@/pages/admin/keys/Keys';
import LangPairClaimReport from '@/pages/admin/langPairClaimReport/LangPairClaimReport';
import Languages from '@/pages/admin/languages/Languages';
import ListeningCalls from '@/pages/admin/listeningCalls/ListeningCalls';
import ListeningGeneratorList from '@/pages/admin/listeningGenerator/ListeningGeneratorList';
import ListeningScores from '@/pages/admin/listeningScores/ListeningScores';
import LostPackagesReport from '@/pages/admin/lostPackagesReport/LostPackagesReport';
import MailCategory from '@/pages/admin/mailCategory/MailCategory';
import MailingReports from '@/pages/admin/mailingReports/MailingReports';
import MailSearch from '@/pages/admin/mailSearch/MailSearch';
import MailReport from '@/pages/admin/mailsReport/MailsReport';
import MailTemplate from '@/pages/admin/mailTemplate/MailTemplate';
import MailTest from '@/pages/admin/mailTest/MailTest';
import MarketList from '@/pages/admin/market/MarketList';
import MarketNew from '@/pages/admin/market/MarketNew';
import MarketShow from '@/pages/admin/market/MarketShow';
import MetaAccountsList from '@/pages/admin/meta/MetaAccountsList';
import NotPickUpCalls from '@/pages/admin/notPickUpCalls/NotPickUpCalls';
import OperatorPaymentReport from '@/pages/admin/operatorPaymentReport/OperatorPaymentReport';
import Order from '@/pages/admin/order/Order';
import OrderFilterTable from '@/pages/admin/orderFitlerTable/OrderFilterTable';
import { OrderFilterTableProvider } from '@/pages/admin/orderFitlerTable/providers/orderFilterTableProvider';
import OrderLangStatsReport from '@/pages/admin/OrderLangStatsReport/OrderLangStatsReport';
import PaymentProductCPLReport from '@/pages/admin/paymentProductCPLReport/PaymentProductCPLReport';
import PaymentReport from '@/pages/admin/paymentReport/PaymentReport';
import PayoutSlip from '@/pages/admin/payoutSlip/PayoutSlip';
import ProductList from '@/pages/admin/product/ProductList';
import ProductNew from '@/pages/admin/product/ProductNew';
import ProductShow from '@/pages/admin/product/ProductShow';
import ProductCPLReport from '@/pages/admin/productCPLReport/ProductCPLReport';
import ProfitabilityReport from '@/pages/admin/profitabilityReport/ProfitabilityReport';
import Promotion from '@/pages/admin/promotion/Promotion';
import QueueList from '@/pages/admin/queue/QueueList/QueueList';
import QueueNew from '@/pages/admin/queue/QueueNew';
import QueueShow from '@/pages/admin/queue/QueueShow';
import Realtimedashboard from '@/pages/admin/realtimeDashboard/Realtimedashboard';
import Recruitment from '@/pages/admin/recruitment/Recruitment';
import RecruitmentMailCategory from '@/pages/admin/recruitmentMailCategory/RecruitmentMailCategory';
import RecruitmentPage from '@/pages/admin/recruitmentPage/RecruitmentPage';
import ResignFeedbackReport from '@/pages/admin/resignFeedbackReport/ResignFeedbackReport';
import ResignTag from '@/pages/admin/resignTag/ResignTag';
import SentOrdersReport from '@/pages/admin/sentOrderReport/SentOrdersReport';
import ServerRefresh from '@/pages/admin/serverRefresh/ServerRefresh';
import SMSCreate from '@/pages/admin/smsCreate/SMSCreate';
import SMSSearch from '@/pages/admin/smsSearch/SMSSearch';
import SpeechToText from '@/pages/admin/speechToText/SpeechToText';
import SupportResignReport from '@/pages/admin/supportResignReport/SupportResignReport';
import SuspicioinReport from '@/pages/admin/suspicionReport/SuspicioinReport';
import TestList from '@/pages/admin/test/TestList';
import Tickets from '@/pages/admin/tickets/Tickets';
import UserNew from '@/pages/admin/user/components/userForm/UserForm';
import UserList from '@/pages/admin/user/UserList';
import UTMReport from '@/pages/admin/utmReport/UTMReport';
import ValidClaims from '@/pages/admin/validClaims/ValidClaims';
import ValidClaimsFeedbackReport from '@/pages/admin/validClaimsFeedbackReport/ValidClaimsFeedbackReport';
import ValidClaimsReport from '@/pages/admin/validClaimsReport/ValidClaimsReport';
import ValidInvoices from '@/pages/admin/validInvoices/ValidInvoices';
import ValidInvoicesReport from '@/pages/admin/validInvoicesReport/ValidInvoicesReport';
import VoipArchive from '@/pages/admin/voipArchive/VoipArchive';
import VoipStatistcs from '@/pages/admin/voipStatistics/VoipStatistcs';
import VoipWorkTime from '@/pages/admin/voipWorkTime/VoipWorkTime';
import CCManagerHours from '@/pages/consultant/ccManagerHours/CCManagerHours';
import ConsultantCalling from '@/pages/consultant/ConsultantCalling';
import ConsultantCallingVonage from '@/pages/consultant/ConsultantCallingVonage';
import ConsultantContact from '@/pages/consultant/consultantContact/ConsultantContact';
import ConsultantContactInbound from '@/pages/consultant/consultantContactInbound/ConsultantContactInbound';
import ConsultantContactOutbound from '@/pages/consultant/consultantContactOutbound/ConsultantContactOutbound';
import ConsultantDashboard from '@/pages/consultant/consultantDashboard/ConsultantDashboard';
import ConsultantDrafts from '@/pages/consultant/consultantDrafts/ConsultantDrafts';
import ConsultantEmailPage from '@/pages/consultant/consultantEmail/ConsultantEmailPage';
import ConsultantFaq from '@/pages/consultant/consultantFaq/ConsultantFaq';
import ConsultantFollowUpPayments from '@/pages/consultant/consultantFollowUpPayments/ConsultantFollowUpPayments';
import ConsultantFollowUpShipments from '@/pages/consultant/consultantFollowUpShipments/ConsultantFollowUpShipments';
import ConsultantGamification from '@/pages/consultant/consultantGamification/ConsultantGamification';
import ConsultantHours from '@/pages/consultant/consultantHours/ConsultantHours';
import ConsultantListeningCalls from '@/pages/consultant/consultantListening/ConsultantListeningCalls';
import ConsultantManagerListeningCalls from '@/pages/consultant/consultantManagerListeningCalls/ConsultantManagerListeningCalls';
import ConsultantManagerScoringListening from '@/pages/consultant/consultantManagerScoringListening/ConsultantManagerScoringListening';
import ConsultantOrders from '@/pages/consultant/consultantOrders/ConsultantOrders';
import ConsultantProfile from '@/pages/consultant/consultantProfile/ConsultantProfile';
import ConsultantSalary from '@/pages/consultant/consultantSalary/ConsultantSalary';
import ConsultantStatistics from '@/pages/consultant/consultantStatistics/ConsultantStatistics';
import ConsultantTeamCallHistory from '@/pages/consultant/consultantTeamCallHistory/ConsultantTeamCallHistory';
import ConsultantTeamLastResult from '@/pages/consultant/consultantTeamLastResult/ConsultantTeamLastResult';
import ConsultantTests from '@/pages/consultant/consultantTests/ConsultantTests';
import ConsultantTickets from '@/pages/consultant/consultantTickets/ConsultantTickets';
import RecruitmentManager from '@/pages/consultant/recruitmentManager/RecruitmentManager';
import LoginPage from '@/pages/login/Login';
import { CallCRMApi } from '../contexts/callingApiContext';
import { CallCRMApiVoipVonage } from '../contexts/callingApiContextVonage';
import QuizReport from '@/pages/admin/quizReport/QuizReport';
import QuizTestReport from '@/pages/admin/quizTestReport/QuizTestReport';
import CCWeeklyReport from '@/pages/admin/ccWeeklyReport/CCWeeklyReport';
import QueueLeadsGuessingReport from '@/pages/admin/queueLeadsGuessing/QueueLeadsGuessingReport';
import Spends from '@/pages/admin/spends/Spends';
import CallingInformation from '@/pages/admin/callingInformation/CallingInformation';
import NotDeliveredPackagesReport from '@/pages/admin/notDeliveredPackagesReport/NotDeliveredPackagesReport';
import PageEventsReport from '@/pages/admin/pageEventsReport/PageEventsReport';

const routes = [
	{
		path: '/login',
		element: <LoginPage />,
		dont_require_auth: false,
	},
	{
		path: '/consultant/dashboard',
		element: (
			<ConsultantDashboardView>
				{' '}
				<ConsultantDashboard />{' '}
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/orders',
		element: (
			<ConsultantDashboardView>
				{' '}
				<ConsultantOrders />{' '}
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/profile',
		element: (
			<ConsultantDashboardView>
				<ConsultantProfile />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/listening',
		element: (
			<ConsultantDashboardView>
				<ConsultantListeningCalls />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/faq',
		element: (
			<ConsultantDashboardView>
				{' '}
				<ConsultantFaq />{' '}
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/tickets',
		element: (
			<ConsultantDashboardView>
				{' '}
				<ConsultantTickets />{' '}
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/salary',
		element: (
			<ConsultantDashboardView>
				{' '}
				<ConsultantSalary />{' '}
			</ConsultantDashboardView>
		),
	},
	// {
	// 	path: '/consultant/team-leader/grade',
	// 	element: (
	// 		<ConsultantDashboardView>
	// 			{' '}
	// 			<ConsultantTeamCurScore />{' '}
	// 		</ConsultantDashboardView>
	// 	),
	// },
	{
		path: '/consultant/team-leader/call-history',
		element: (
			<ConsultantDashboardView>
				{' '}
				<ConsultantTeamCallHistory />{' '}
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/team-leader/suspicion',
		element: (
			<ConsultantDashboardView>
				{' '}
				<SuspicioinReport />{' '}
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/team-leader/hours',
		element: (
			<ConsultantDashboardView>
				<CCManagerHours />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/team-leader/recruitment',
		element: (
			<ConsultantDashboardView>
				<RecruitmentManager />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/team-leader/listening',
		element: (
			<ConsultantDashboardView>
				{' '}
				<ConsultantManagerListeningCalls />{' '}
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/team-leader/listening-scoring',
		element: (
			<ConsultantDashboardView>
				{' '}
				<ConsultantManagerScoringListening />{' '}
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/team-leader/result',
		element: (
			<ConsultantDashboardView>
				{' '}
				<ConsultantTeamLastResult />{' '}
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/team-leader/daily-report',
		element: (
			<ConsultantDashboardView>
				<ConsultantTeamCallHistory />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/statistics',
		element: (
			<ConsultantDashboardView>
				<ConsultantStatistics />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/contact/:id',
		element: (
			<ConsultantDashboardView>
				<ConsultantContact />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/drafts',
		element: (
			<ConsultantDashboardView>
				<ConsultantDrafts />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/tests',
		element: (
			<ConsultantDashboardView>
				<ConsultantTests />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/gamification',
		element: (
			<ConsultantDashboardView>
				<ConsultantGamification />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/follow-up-shipments',
		element: (
			<ConsultantDashboardView>
				<ConsultantFollowUpShipments />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/follow-up-payments',
		element: (
			<ConsultantDashboardView>
				<ConsultantFollowUpPayments />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/contact/outbound/:id',
		element: <ConsultantContactOutbound />,
	},
	{
		path: '/consultant/calling',
		element: (
			<CallCRMApi>
				<ConsultantCalling />
			</CallCRMApi>
		),
	},
	{
		path: '/consultant/calling/vonage',
		element: (
			<CallCRMApiVoipVonage>
				<ConsultantCallingVonage />
			</CallCRMApiVoipVonage>
		),
	},
	{
		path: '/report/operator-payment-report',
		element: (
			<AdminDashboardView>
				<OperatorPaymentReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/consultant/contact/inbound/:id',
		element: (
			<ConsultantDashboardView>
				<ConsultantContactInbound />{' '}
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/hours',
		element: (
			<ConsultantDashboardView>
				<ConsultantHours />
			</ConsultantDashboardView>
		),
	},
	{
		path: '/consultant/email',
		element: (
			<ConsultantDashboardView>
				<ConsultantEmailPage />
			</ConsultantDashboardView>
		),
	},

	{
		path: '/cc/gamification',
		element: (
			<AdminDashboardView>
				<CCGamification />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/gamification/new',
		element: (
			<AdminDashboardView>
				<GamificationNew />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/payout-slip',
		element: (
			<AdminDashboardView>
				<PayoutSlip />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/speech-to-text',
		element: (
			<AdminDashboardView>
				<SpeechToText />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/recruitment',
		element: (
			<AdminDashboardView>
				<Recruitment />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/follow-up-shipments',
		element: (
			<AdminDashboardView>
				<FollowUpShipments />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/follow-up-payments',
		element: (
			<AdminDashboardView>
				<FollowUpPayments />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/hours',
		element: (
			<AdminDashboardView>
				<CCHours />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/hours_report',
		element: (
			<AdminDashboardView>
				<HoursReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/payment',
		element: (
			<AdminDashboardView>
				<CCPayment />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/payment_kdr',
		element: (
			<AdminDashboardView>
				<CCPaymentKDR />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/payment-short',
		element: (
			<AdminDashboardView>
				<CCPaymentShort />
			</AdminDashboardView>
		),
	},
	{
		path: '/cc/files',
		element: (
			<AdminDashboardView>
				<File />
			</AdminDashboardView>
		),
	},
	{
		path: '/mail/recruitment-mail',
		element: (
			<AdminDashboardView>
				<RecruitmentMailCategory />
			</AdminDashboardView>
		),
	},
	{
		path: '/dashboard',
		element: (
			<AdminDashboardView>
				<Dashboard />
			</AdminDashboardView>
		),
	},
	{
		path: '/dashboard/tickets',
		element: (
			<AdminDashboardView>
				<Tickets />
			</AdminDashboardView>
		),
	},
	{
		path: '/dashboard/contacts',
		element: (
			<AdminDashboardView>
				<ContactsFilterTable />
			</AdminDashboardView>
		),
	},
	{
		path: '/dashboard/orders',
		element: (
			<AdminDashboardView>
				<OrderFilterTableProvider>
					<OrderFilterTable />
				</OrderFilterTableProvider>
			</AdminDashboardView>
		),
	},
	{
		path: '/dashboard/contact/:id',
		element: (
			<AdminDashboardView>
				<Contact />
			</AdminDashboardView>
		),
	},
	{
		path: '/dashboard/order/:id',
		element: (
			<AdminDashboardView>
				<Order />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/effective',
		element: (
			<AdminDashboardView>
				<EffectiveReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/lang-pair-claim',
		element: (
			<AdminDashboardView>
				<LangPairClaimReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/lost-packages',
		element: (
			<AdminDashboardView>
				<LostPackagesReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/contacts-road',
		element: (
			<AdminDashboardView>
				<ContactsRoad />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/cost-per-lead',
		element: (
			<AdminDashboardView>
				<CostPerLead />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/suspicion',
		element: (
			<AdminDashboardView>
				<SuspicioinReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/utm',
		element: (
			<AdminDashboardView>
				<UTMReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/sent-orders',
		element: (
			<AdminDashboardView>
				<SentOrdersReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/product-cpl',
		element: (
			<AdminDashboardView>
				<ProductCPLReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/payment-product-cpl',
		element: (
			<AdminDashboardView>
				<PaymentProductCPLReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/daily-market',
		element: (
			<AdminDashboardView>
				<DailyMarket />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/not-pick-up-calls',
		element: (
			<AdminDashboardView>
				<NotPickUpCalls />
			</AdminDashboardView>
		),
	},

	{
		path: '/report/daily',
		element: (
			<AdminDashboardView>
				<DailyReport />
			</AdminDashboardView>
		),
	},

	{
		path: '/report/payment',
		element: (
			<AdminDashboardView>
				<PaymentReport />
			</AdminDashboardView>
		),
	},

	{
		path: '/report/resign',
		element: (
			<AdminDashboardView>
				<SupportResignReport />
			</AdminDashboardView>
		),
	},

	{
		path: '/report/order-langs-stats',
		element: (
			<AdminDashboardView>
				<OrderLangStatsReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/mails',
		element: (
			<AdminDashboardView>
				<MailReport />
			</AdminDashboardView>
		),
	},
	// {
	// 	path: '/report/grade',
	// 	element: (
	// 		<AdminDashboardView>
	// 			<GradeReport />
	// 		</AdminDashboardView>
	// 	),
	// },
	{
		path: '/report/consultant',
		element: (
			<AdminDashboardView>
				<CallHistoryCsv />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/valid-claims-feedback-report',
		element: (
			<AdminDashboardView>
				<ValidClaimsFeedbackReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/resign-new',
		element: (
			<AdminDashboardView>
				<ResignFeedbackReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/valid-claims-report',
		element: (
			<AdminDashboardView>
				<ValidClaimsReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/profitability',
		element: (
			<AdminDashboardView>
				<ProfitabilityReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/quiz',
		element: (
			<AdminDashboardView>
				<QuizReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/quiz-test',
		element: (
			<AdminDashboardView>
				<QuizTestReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/page-events',
		element: (
			<AdminDashboardView>
				<PageEventsReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/cc-weekly',
		element: (
			<AdminDashboardView>
				<CCWeeklyReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/queue-leads-guessing',
		element: (
			<AdminDashboardView>
				<QueueLeadsGuessingReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/report/not-delivered-packages',
		element: (
			<AdminDashboardView>
				<NotDeliveredPackagesReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/market/new',
		element: (
			<AdminDashboardView>
				<MarketNew />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/server-refresh',
		element: (
			<AdminDashboardView>
				<ServerRefresh />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/test/list',
		element: (
			<AdminDashboardView>
				<TestList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/drafts/list',
		element: (
			<AdminDashboardView>
				<DocumentsList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/blackboard/list',
		element: (
			<AdminDashboardView>
				<BlackboardList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/faq/list',
		element: (
			<AdminDashboardView>
				<FaqList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/dictionary',
		element: (
			<AdminDashboardView>
				<Dictionary />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/gamification',
		element: (
			<AdminDashboardView>
				<Gamification />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/keys',
		element: (
			<AdminDashboardView>
				<Keys />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/companies',
		element: (
			<AdminDashboardView>
				<Companies />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/department',
		element: (
			<AdminDashboardView>
				<Department />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/invoice-config',
		element: (
			<AdminDashboardView>
				<InvoiceConfig />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/listening-generator',
		element: (
			<AdminDashboardView>
				<ListeningGeneratorList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/meta',
		element: (
			<AdminDashboardView>
				<MetaAccountsList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/languages',
		element: (
			<AdminDashboardView>
				<Languages />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/market/list',
		element: (
			<AdminDashboardView>
				<MarketList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/market/show/:id',
		element: (
			<AdminDashboardView>
				<MarketShow />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/product/new',
		element: (
			<AdminDashboardView>
				<ProductNew />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/product/list',
		element: (
			<AdminDashboardView>
				<ProductList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/product/show/:id',
		element: (
			<AdminDashboardView>
				<ProductShow />
			</AdminDashboardView>
		),
	},

	{
		path: '/settings/queue/new',
		element: (
			<AdminDashboardView>
				<QueueNew />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/queue/list',
		element: (
			<AdminDashboardView>
				<QueueList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/queue/show/:id',
		element: (
			<AdminDashboardView>
				<QueueShow />
			</AdminDashboardView>
		),
	},

	{
		path: '/settings/dictionary/new',
		element: (
			<AdminDashboardView>
				<MarketNew />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/promotion',
		element: (
			<AdminDashboardView>
				<Promotion />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/dictionary/list',
		element: (
			<AdminDashboardView>
				<MarketList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/dictionary/show/:id',
		element: (
			<AdminDashboardView>
				<MarketShow />
			</AdminDashboardView>
		),
	},

	{
		path: '/settings/user/new',
		element: (
			<AdminDashboardView>
				<UserNew />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/user/list',
		element: (
			<AdminDashboardView>
				<UserList />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/invoice-templates',
		element: (
			<AdminDashboardView>
				<InvoiceTemplates />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/bonus',
		element: (
			<AdminDashboardView>
				<Bonus />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/recruitment-page',
		element: (
			<AdminDashboardView>
				<RecruitmentPage />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/claim-tags',
		element: (
			<AdminDashboardView>
				<ClaimTag />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/resign-tags',
		element: (
			<AdminDashboardView>
				<ResignTag />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/call-center-position',
		element: (
			<AdminDashboardView>
				<CallCenterPosition />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/dynamic-mail-content',
		element: (
			<AdminDashboardView>
				<DynamicMailContent />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/dynamic-mail-attachment',
		element: (
			<AdminDashboardView>
				<DynamicMailAttachment />
			</AdminDashboardView>
		),
	},
	{
		path: '/mail/search',
		element: (
			<AdminDashboardView>
				<MailSearch />
			</AdminDashboardView>
		),
	},
	{
		path: '/mail/template',
		element: (
			<AdminDashboardView>
				<MailTemplate />
			</AdminDashboardView>
		),
	},
	{
		path: '/mail/category',
		element: (
			<AdminDashboardView>
				<MailCategory />
			</AdminDashboardView>
		),
	},
	{
		path: '/mail/test',
		element: (
			<AdminDashboardView>
				<MailTest />
			</AdminDashboardView>
		),
	},
	{
		path: '/mail/attachments',
		element: (
			<AdminDashboardView>
				<Attachments />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/realtime-dashboard',
		element: (
			<AdminDashboardView>
				<Realtimedashboard />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/working-time',
		element: (
			<AdminDashboardView>
				<VoipWorkTime />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/statistics',
		element: (
			<AdminDashboardView>
				<VoipStatistcs />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/archive',
		element: (
			<AdminDashboardView>
				<VoipArchive />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/listening',
		element: (
			<AdminDashboardView>
				<ListeningCalls />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/listening-scores',
		element: (
			<AdminDashboardView>
				<ListeningScores />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/calling/search',
		element: (
			<AdminDashboardView>
				<CallingSearch />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/sms/search',
		element: (
			<AdminDashboardView>
				<SMSSearch />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/sms/create',
		element: (
			<AdminDashboardView>
				<SMSCreate />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/listening-marks',
		element: (
			<AdminDashboardView>
				{' '}
				<HeadCcManagerScoringCalls />{' '}
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/calling-information',
		element: (
			<AdminDashboardView>
				<CallingInformation />
			</AdminDashboardView>
		),
	},
	{
		path: '/voip/listening-scoring',
		element: (
			<AdminDashboardView>
				<HeadCcManagerScoringListening />
			</AdminDashboardView>
		),
	},
	{
		path: '/hr/claim/search',
		element: (
			<AdminDashboardView>
				<ClaimsSearch />
			</AdminDashboardView>
		),
	},

	{
		path: '/hr/claim/not_ended_claims',
		element: (
			<AdminDashboardView>
				<ClaimNotEnded />
			</AdminDashboardView>
		),
	},
	{
		path: '/hr/invoices',
		element: (
			<AdminDashboardView>
				<Invoices />
			</AdminDashboardView>
		),
	},
	{
		path: '/valid-invoices',
		element: (
			<AdminDashboardView>
				<ValidInvoices />
			</AdminDashboardView>
		),
	},
	{
		path: '/valid-claims',
		element: (
			<AdminDashboardView>
				<ValidClaims />
			</AdminDashboardView>
		),
	},
	{
		path: '/hr/claims-report',
		element: (
			<AdminDashboardView>
				<ClaimsReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/hr/invoices-report',
		element: (
			<AdminDashboardView>
				<InvoicesReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/valid-invoices-report',
		element: (
			<AdminDashboardView>
				<ValidInvoicesReport />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/mailing-reports',
		element: (
			<AdminDashboardView>
				<MailingReports />
			</AdminDashboardView>
		),
	},
	{
		path: '/settings/spends',
		element: (
			<AdminDashboardView>
				<Spends />
			</AdminDashboardView>
		),
	},
];

export default routes;
